export function getMobileNetworkRecoveryState(input: { online: boolean; rechecking?: boolean; recentlyRestored?: boolean }) {
  if (input.rechecking) {
    return { tone: "warning" as const, title: "Verificando conexão…", description: "Aguarde antes de repetir qualquer ação." };
  }
  if (!input.online) {
    return {
      tone: "danger" as const,
      title: "Sem conexão",
      description: "Ações como chegada, pagamento e atualização da agenda não foram enviadas. Reconecte antes de tentar novamente.",
    };
  }
  if (input.recentlyRestored) {
    return {
      tone: "success" as const,
      title: "Conexão restabelecida",
      description: "Os dados abertos foram atualizados. Refaça apenas a ação que não recebeu confirmação.",
    };
  }
  return null;
}
